import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
export interface ISettings{
  apiUrl:string
}
@Injectable({
  providedIn: 'root'
})

export class SettingService {

  private settings: ISettings;
  constructor(private http: HttpClient) {

  }



  public loadSettings() {
    this.http.get("./assets/enviroment.json").subscribe((res:ISettings) => {
      console.log(res)
      this.settings = res
    })
  }
  public getSetting() {
    return this.settings
  }

 /*  public getSetting() {

    this.getJSON().subscribe(res => {
      console.log(res)
      return res.apiUrl
    })
  } */
}
